import { getSupabaseClient } from "../../services/supabaseClient.js";

export async function upsertPrimaryEventContact({ eventId, contactId }) {
  const supabase = getSupabaseClient();

  const { error: resetError } = await supabase
    .from("event_contacts")
    .update({ is_primary: false })
    .eq("event_id", eventId);

  if (resetError) throw resetError;

  const { error: upsertError } = await supabase
    .from("event_contacts")
    .upsert(
      { event_id: eventId, contact_id: contactId, is_primary: true },
      { onConflict: "event_id,contact_id" }
    );

  if (upsertError) throw upsertError;
}

export async function upsertPrimaryEventVenue({ teamId, eventId, venueId }) {
  const supabase = getSupabaseClient();

  const { error: resetError } = await supabase
    .from("event_venues")
    .update({ is_primary: false })
    .eq("event_id", eventId);

  if (resetError) throw resetError;

  const { error: upsertError } = await supabase
    .from("event_venues")
    .upsert(
      { team_id: teamId, event_id: eventId, venue_id: venueId, is_primary: true },
      { onConflict: "event_id,venue_id" }
    );

  if (upsertError) throw upsertError;
}

export async function fetchEventById(eventId) {
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from("events")
    .select("*")
    .eq("id", eventId)
    .single();
  if (error) throw error;
  return data;
}

export async function fetchPrimaryContactId(eventId) {
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from("event_contacts")
    .select("contact_id,is_primary")
    .eq("event_id", eventId)
    .eq("is_primary", true)
    .maybeSingle();
  if (error) throw error;
  return data?.contact_id || "";
}

export async function fetchPrimaryVenueId(eventId) {
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from("event_venues")
    .select("venue_id,is_primary")
    .eq("event_id", eventId)
    .eq("is_primary", true)
    .maybeSingle();
  if (error) throw error;
  return data?.venue_id || "";
}

export async function fetchContact(contactId) {
  if (!contactId) return null;
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from("contacts")
    .select("*")
    .eq("id", contactId)
    .single();
  if (error) throw error;
  return data;
}

export async function fetchVenue(venueId) {
  if (!venueId) return null;
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from("venues")
    .select("*")
    .eq("id", venueId)
    .single();
  if (error) throw error;
  return data;
}
